import { Trans, useLingui } from '@lingui/react/macro';

import InlineText from '@/design_system/Typography/InlineText';
import IconPackageIssue from '@/icons/PackageIssue.svg';
import { BaseNotification } from '@/layouts/App/Navbar/NotificationList/components/BaseNotification/BaseNotification';
import type { TNotificationOfType } from '@/models/notification';

export const ExchangeStockAvailabilityRefusedNotification = ({
  notification,
}: {
  notification: TNotificationOfType<'exchange_stock_availability_refused'>;
}) => {
  const { t } = useLingui();

  const stockLocationName = notification.data.stockLocationName;
  const replacementProductName = notification.data.replacementProductName;

  return (
    <BaseNotification
      notificationLabel={t({
        id: 'notification.exchange-stock-availability-refused.label',
        message: `${stockLocationName} declined stock availability for item ${replacementProductName}`,
      })}
      icon={<IconPackageIssue />}
      type="warning"
      notification={notification}
      notificationHeader={(color) => (
        <Trans id="notification.exchange-stock-availability-refused">
          <InlineText weight="medium" color={color}>
            {stockLocationName}
          </InlineText>{' '}
          declined stock availability for item {replacementProductName}
        </Trans>
      )}
    />
  );
};
